/**
 * A escala de tamanho de fonte dos aplicativos
 * (`components/ThemedText/types/enums.ts`), para um número significar o mesmo
 * na web e no celular.
 *
 * Mora aqui, e não só no `tailwind.config.ts`, porque o `cn` de `lib/utils.ts`
 * também precisa dela: o `tailwind-merge` não conhece `text-small` nem
 * `text-h5`, e sem a lista os trata como COR. Aí `text-small` descartava a cor
 * do texto que viesse antes dele na mesma chamada, e o botão principal saía com
 * o texto escuro em vez de branco.
 */
export const typeScale = {
  caption: ["0.75rem", { lineHeight: "1rem" }], // 12
  small: ["0.875rem", { lineHeight: "1.25rem" }], // 14
  medium: ["1rem", { lineHeight: "1.5rem" }], // 16
  subtitle: ["1.125rem", { lineHeight: "1.75rem" }], // 18
  h6: ["1rem", { lineHeight: "1.5rem" }], // 16
  h5: ["1.25rem", { lineHeight: "1.75rem" }], // 20
  h4: ["1.5rem", { lineHeight: "2rem" }], // 24
  h3: ["2rem", { lineHeight: "2.5rem" }], // 32
  h2: ["2.25rem", { lineHeight: "2.75rem" }], // 36
  h1: ["2.5rem", { lineHeight: "3rem" }], // 40
} satisfies Record<string, [string, { lineHeight: string }]>;
